import { TransactionWizardContext } from "../types/transactionWizardContext";
import { TransactionWizardEvent } from "../types/TransactionWizardEvent";

export const setNameAndDepotAction = (
  context: TransactionWizardContext,
  event: TransactionWizardEvent
) => {
  if (
    event.type !== "NAME_AND_DEPOT_SELECTED" &&
    event.type !== "CREATE_NEW_DEPOT"
  )
    throw new Error(`Invalid event type ${event.type}`);

  const selectedDepot =
    event.type === "NAME_AND_DEPOT_SELECTED"
      ? context.selectableDepots?.find((d) => d.id === event.depotId)
      : undefined;

  return {
    investmentValues: {
      ...context.investmentValues,
      depotId:
        event.type === "NAME_AND_DEPOT_SELECTED"
          ? event.depotId
          : context.investmentValues.depotId,
      name: event.name,
    },
    bookingValues: {
      ...context.bookingValues,
      comment: event.comment,
      accountCurrency:
        selectedDepot?.currency ?? context.bookingValues.accountCurrency,
    },
  };
};
